import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

import App from './App.tsx';

import './index.css';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://894fda3742af4bfe873dd96f1337644b@o64216.ingest.sentry.io/4505466338017280',
    integrations: [
      // new Sentry.BrowserTracing({
      //   // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      //   tracePropagationTargets: [
      //     'localhost',
      //     /^https:\/\/yourserver\.io\/api/,
      //   ],
      // }),
    ],
  });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
